import React from "react";
import { CheckCircle2 } from "lucide-react";

const plans = [
  {
    name: "Free",
    tag: "شروع رایگان",
    desc: "برای آشنایی و استفاده روزمره از دستیار",
    originalPrice: null,
    price: "رایگان",
    discount: null,
    features: [
      "چت AI عمومی (آموزشی و راهنمایی کلی)",
      "پاسخ به سوالات مالی و مفاهیم پایه",
      "تحلیل‌های عمومی (بدون شخصی‌سازی عمیق)",
      "بدون دسترسی به منتور انسانی",
    ],
  },
  {
    name: "Silver",
    tag: "پیشنهادی",
    popular: true,
    desc: "برای رشد مهارت و تصمیم‌گیری بهتر",
    originalPrice: "999 هزار تومن",
    price: "$499 هزارتومن",
    discount: "40% تخفیف",
    period: "/ماه",
    features: [
      "AI شخصی‌سازی‌شده بر اساس پروفایل کاربر",
      "Mentor Prompt Pack (پرامپت‌های طراحی‌شده توسط منتورها)",
      "مدیریت ریسک پایه (پوزیشن‌سایز، حدضرر، R/R)",
      "تحلیل هفتگی عملکرد و اشتباهات رایج",
      "پشتیبانی چت (محدود)",
    ],
  },
  {
    name: "Gold",
    tag: "حرفه‌ای",
    desc: "برای کاربران جدی‌تر با نیاز به همراهی نزدیک‌تر",
    originalPrice: "11999 هزار تومن",
    price: "8999 هزار تومن",
    discount: "30% تخفیف",
    period: "/سالانه",
    features: [
      "تمام امکانات Silver",
      "تحلیل پیشرفته‌تر و گزارش‌های دقیق‌تر",
      "منتور VIP (دسترسی محدود و زمان‌بندی‌شده)",
      "بررسی ژورنال معاملاتی و بازخورد عملی",
      "پشتیبانی چت اولویت‌دار",
      "تحلیل روزانه بازار (در صورت فعال‌سازی)",
    ],
  },
];

function Feature({ children }) {
  return (
    <li className="flex items-start gap-3">
      <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-green-600" />
      <span className="text-sm leading-6 text-gray-700">{children}</span>
    </li>
  );
}

export default function PricingCards() {
  return (
    <div className="w-full px-4 py-16 bg-gray-50">
      <div className="mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900">
            پلن‌های عضویت
          </h2>
          <p className="mt-4 text-lg text-gray-600">
           بنظر من حاج صدرا رایگان شروع کن بعدش تفاوت رو حس کردی اشتراک بگیر
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-3">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`relative rounded-2xl border-2 bg-white shadow-lg transition-all hover:shadow-xl ${
                plan.popular
                  ? "border-emerald-500 ring-2 ring-emerald-500 ring-offset-2"
                  : "border-gray-200"
              }`}
            >
              {/* برچسب محبوب */}
              {plan.popular && (
                <div className="absolute -top-5 left-1/2 -translate-x-1/2">
                  <span className="bg-emerald-500 text-white px-4 py-1.5 rounded-full text-sm font-semibold">
                    {plan.tag}
                  </span>
                </div>
              )}

              <div className="p-8">
                {/* عنوان و برچسب */}
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-2xl font-bold text-gray-900">{plan.name}</h3>
                  {!plan.popular && plan.tag && (
                    <span className="text-sm font-medium text-gray-500">{plan.tag}</span>
                  )}
                </div>

                <p className="text-gray-600 text-sm mb-8">{plan.desc}</p>

                {/* قیمت - اینجا اصلاح شده */}
                <div className="mb-8">
                  {plan.originalPrice ? (
                    <>
                      <div className="flex items-baseline gap-3">
                        <span className="text-4xl font-bold text-gray-900">
                          {plan.price}
                        </span>
                        <span className="text-lg text-gray-500">{plan.period}</span>
                      </div>
                      <div className="flex items-center gap-3 mt-3">
                        <span className="text-lg text-gray-400 line-through">
                          {plan.originalPrice}{plan.period}
                        </span>
                        {plan.discount && (
                          <span className="bg-red-100 text-red-700 text-xs font-semibold px-3 py-1 rounded-full">
                            {plan.discount}
                          </span>
                        )}
                      </div>
                    </>
                  ) : (
                    <div className="text-4xl font-bold text-emerald-600">
                      {plan.price}
                    </div>
                  )}
                </div>

                {/* ویژگی‌ها */}
                <ul className="space-y-4 mb-10">
                  {plan.features.map((feature, idx) => (
                    <Feature key={idx}>{feature}</Feature>
                  ))}
                </ul>

                {/* دکمه اقدام */}
                <button
                  className={`w-full py-3 rounded-xl font-semibold transition-all ${
                    plan.popular
                      ? "bg-emerald-500 text-white hover:bg-emerald-600"
                      : plan.name === "Free"
                      ? "bg-gray-100 text-gray-800 hover:bg-gray-200"
                      : "bg-blue-600 text-white hover:bg-blue-700"
                  }`}
                >
                  {plan.name === "Free" ? "شروع رایگان" : "انتخاب پلن"}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}